// extracted by mini-css-extract-plugin
export default {"landingBg":"Landing_landingBg__Q4zbN"};